import { Injectable } from '@angular/core';
import {ActivatedRouteSnapshot, Resolve, RouterStateSnapshot} from '@angular/router';
import {Observable} from 'rxjs';
import {BranchDto} from 'src/app/services/api-client/models';
import {BranchRestControllerService} from 'src/app/services/api-client/services';

@Injectable()
export class BranchOfferResolver implements Resolve<BranchDto[]> {

  constructor(
    public branchOfferService: BranchRestControllerService
  ) {}

  resolve(route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<BranchDto[]> {
    return this.branchOfferService.getBranches();
  }
}
